export default __webpack_public_path__ + "static/deep-laugh-dc5999f0ed6a8ddd799972d51d621dd0.mp3";